const prefix = '@@angular-translate';
const CHANGE_LANGUAGE = `${prefix}/CHANGE_LANGUAGE`;
const CHANGE_LANGUAGE_ERROR = `${prefix}/CHANGE_LANGUAGE_ERROR`;
const LANGUAGE_READY = `${prefix}/LANGUAGE_READY`;

/**
 * @param {Object} payload
 * @param {String} payload.key The key of the language to use
 * @return {ReduxAction}
 */
export function changeLanguage(payload={}) {
  return {
    type: CHANGE_LANGUAGE,
    payload,
  };
}
changeLanguage.TYPE = CHANGE_LANGUAGE;


/**
 * @param {Object} payload
 * @param {String} payload.key The key of the language to use
 * @param {Error} payload.err The error that occurred
 * @return {ReduxAction}
 */
export function changeLanguageError(payload={}) {
  return {
    type: CHANGE_LANGUAGE_ERROR,
    payload,
  };
}
changeLanguageError.TYPE = CHANGE_LANGUAGE_ERROR;


/**
 * @param {Object} payload
 * @param {String} payload.key The key of the language that is ready to use
 * @return {ReduxAction}
 */
export function languageReady(payload={}) {
  return {
    type: LANGUAGE_READY,
    payload,
  };
}
languageReady.TYPE = LANGUAGE_READY;



// WEBPACK FOOTER //
// ./src/js/_libs/angular-translate-redux/src/actions.js